import React, { useEffect } from "react";
// import * as yup from 'yup';
import { Button, Col, Row, Space, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  // objectToFormData,
  findLodash,
  hasAccess,
} from "../../../../utils";
// import { addEmployees, updateEmployees } from '../../../../actions/employees';
import { useHistory } from "react-router-dom";
import { userCards } from "../../../../actions/cards/cards";
import DeleteIcon from "../../../../assets/icons/delete.png";
import EditIcon from "../../../../assets/icons/edit.png";
import PageHeader from "../../../PageHeader";
import "./../userControl.css";

const { TabPane } = Tabs;

const UserDetails = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [userData, setUserData] = React.useState({});
  const employeesResponse = useSelector(
    (state) => state.employees.employees || {},
  );
  const setTab = () => {};
  const userCardsResponse = useSelector((state) => state.cards.userCards || {});
  const { data: { response: { cards: userCardsList = [] } = {} } = {} } =
    userCardsResponse;
  useEffect(() => {
    if (userData?.id)
      dispatch(userCards({ source: "admin", user_id: userData?.user_id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  React.useEffect(() => {
    if (employeesResponse.success && props.selectedRecord) {
      const currentValues =
        findLodash(
          props?.checker
            ? employeesResponse?.data?.response?.checkers
            : employeesResponse?.data?.response?.employees,
          {
            id: props.selectedRecord,
          },
        ) || {};
      setUserData(currentValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);
  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`User`}
          navigation={{
            "View user details and Edit": "",
          }}
        />
      </div>
      <div className="tabContentWrapperSmall userDetailHead">
        <div>
          <Space size="middle">
            <div className="detailsCircle">
              {userData?.name ? userData?.name.charAt(0).toUpperCase() : "Z"}
            </div>
            <div>
              <h3 style={{ color: "#333" }}>{userData?.name}</h3>
              <span>{userData?.email}</span>
            </div>
          </Space>
          <div className="floatRight">
            <Space size="middle">
              {props?.checker ? null : (
                <div
                  className={` status status_${
                    userData?.status ? userData?.status : ""
                  }`}
                >
                  {userData?.status ? userData?.status?.replace(/_/g, " ") : ""}
                </div>
              )}
              <button onClick={() => props.showEditModal(props.selectedRecord)}>
                <img src={EditIcon} alt={"logo"} className="action-logo" />
              </button>
              <button
                onClick={() => props.showDeleteModal(props.selectedRecord)}
              >
                <img src={DeleteIcon} alt={"logo"} className="action-logo" />
              </button>
            </Space>
          </div>
        </div>
        {props?.checker ||
        userData?.status !== "rejected" ? null : userData?.reject_reason ? (
          <div>
            <h6
              style={{
                color: "var(--text-primary)",
                fontSize: "1rem",
                marginBottom: "0rem",
                marginTop: "0.5rem",
              }}
            >
              Reason for Rejection :
            </h6>
            <p
              style={{
                marginBottom: "0rem",
                lineHeight: "18px",
                color: "#f15363",
                fontSize: "1rem",
              }}
            >
              {userData?.reject_reason ? userData?.reject_reason : ""}
            </p>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="userContentWrapper mt1">
        <Tabs
          onChange={setTab}
          type="card"
          size="large"
          className="custom-tabs"
        >
          <TabPane tab="Overview" key="preferences">
            {props?.checker ? (
              <Row>
                <Col span={10}>
                  <p>
                    <b>Name</b>
                  </p>
                  <p>{userData?.name}</p>
                  <p className="mt2">
                    <b>Mobile Number</b>
                  </p>
                  <p>{userData?.primary_phone}</p>
                </Col>
                <Col span={8}>
                  <p>
                    <b>Email</b>
                  </p>
                  <p>{userData?.email}</p>
                  <p>
                    <b>Role</b>
                  </p>
                  <p>{userData?.roles?.toString()}</p>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col span={10}>
                  <p>
                    <b>First Name</b>
                  </p>
                  <p>{userData?.first_name}</p>
                  <p>
                    <b>Last Name</b>
                  </p>
                  <p>{userData?.last_name}</p>
                  <p>
                    <b>DOB</b>
                  </p>
                  <p>{userData?.dob}</p>
                  <p>
                    <b>Employee ID</b>
                  </p>
                  <p>{userData?.emp_id || "-"}</p>
                  <p>
                    <b>Nationality</b>
                  </p>
                  <p>{userData?.nationality}</p>

                  {/* <p>
                    <b>Customer Type</b>
                  </p>
                  <p>{userData?.customer_type}</p> */}
                  <p>
                    <b>Occupation</b>
                  </p>
                  <p>{userData?.occupation}</p>
                  <p>
                    <b>Address Line 2</b>
                  </p>
                  <p>{userData?.address_line_2}</p>

                  <p>
                    <b>Pincode</b>
                  </p>
                  <p>{userData?.pincode}</p>
                  <p>
                    <b>State</b>
                  </p>
                  <p>{userData?.state}</p>
                  <p>
                    <b>Communication Address 2</b>
                  </p>
                  <p>{userData?.communication_address_line_2}</p>

                  <p>
                    <b>Communication Pincode</b>
                  </p>
                  <p>{userData?.communication_pincode}</p>
                  <p>
                    <b>Communication State</b>
                  </p>
                  <p>{userData?.communication_state}</p>
                  <p>
                    <b>KYC Method</b>
                  </p>
                  <p>{userData?.kyc_method}</p>
                  <p>
                    <b>OVD Details</b>
                  </p>
                  <p>{userData?.ovd_details}</p>

                  {userData?.custom_fields &&
                    userData?.custom_fields?.length > 0 &&
                    userData?.custom_fields.map((ele) => {
                      return (
                        <>
                          <p className="mt2">
                            <b>{ele.column_name}</b>
                          </p>
                          <p>
                            {ele.value !== "undefined" && ele.value
                              ? ele.value
                              : "-"}
                          </p>
                        </>
                      );
                    })}
                </Col>
                <Col span={8}>
                  <p>
                    <b>Middle Name</b>
                  </p>
                  <p>{userData?.middle_name || "-"}</p>
                  {/* <p>
                    <b>Last Name</b>
                  </p>
                  <p>{userData?.last_name}</p> */}
                  <p>
                    <b>Email</b>
                  </p>
                  <p>{userData?.email}</p>

                  <p>
                    <b>Mobile Number</b>
                  </p>
                  <p>{userData?.primary_phone}</p>
                  <p>
                    <b>Role</b>
                  </p>
                  <p>{userData?.roles?.toString()}</p>
                  <p>
                    <b>Gender</b>
                  </p>
                  <p>
                    <b>Address Line 1</b>
                  </p>
                  <p>{userData?.address_line_1}</p>
                  <p>{userData?.gender}</p>
                  <p>
                    <b>Address Line 3</b>
                  </p>
                  <p>{userData?.address_line_3}</p>
                  <p>
                    <b>City</b>
                  </p>
                  <p>{userData?.city}</p>
                  <p>
                    <b>Communication Address 1</b>
                  </p>
                  <p>{userData?.communication_address_line_1}</p>
                  <p>
                    <b>Communication Address 3</b>
                  </p>
                  <p>{userData?.communication_address_line_3}</p>
                  <p>
                    <b>Communication City </b>
                  </p>
                  <p>{userData?.communication_city}</p>
                  <p>
                    <b>KYC Type</b>
                  </p>
                  <p>{userData?.kyc_type}</p>
                  <p>
                    <b>OVD Type</b>
                  </p>
                  <p>{userData?.ovd_type}</p>
                  <p className="mt2">
                    <b>Approvers</b>
                  </p>
                  {userData?.approvers &&
                    userData?.approvers?.length > 0 &&
                    userData?.approvers?.map((ele) => (
                      <p>{`${ele?.name} (${ele?.role})`}</p>
                    ))}
                  {/* <p>
                    <b>Cost center</b>
                  </p>
                  <p>{userData?.cost_center?.name}</p>
                  <p>
                    <b>Project</b>
                  </p>
                  <p>{userData?.project?.name}</p> */}

                  {/* <p>
                    <b>PAN</b>
                  </p>
                  <p>{userData?.pan}</p> */}
                </Col>
              </Row>
            )}
            <Button
              key="5"
              disabled={!hasAccess("users_and_controls", "write")}
              onClick={() => props.showEditModal(props.selectedRecord)}
              className="formButton mt3"
            >
              Edit
            </Button>
            <Button
              key="6"
              className="cancelButton ml1 mt3"
              onClick={props.handleRowClick}
            >
              Back
            </Button>
          </TabPane>
          {props?.checker ? null : (
            <>
              <TabPane tab="Grades and Designations" key="fields3">
                <Row>
                  <Col span={6}>
                    <p>
                      <b>Designation</b>
                    </p>
                    <p className="mt2">
                      <b>Grade/Level</b>
                    </p>
                  </Col>
                  <Col span={8}>
                    <p>{userData?.designation?.title}</p>
                    <p className="mt2">{userData?.grade?.level}</p>
                  </Col>
                </Row>
                <Button
                  key="5"
                  disabled={!hasAccess("users_and_controls", "write")}
                  onClick={() => props.showEditModal(props.selectedRecord)}
                  className="formButton mt3"
                >
                  Edit
                </Button>
                <Button
                  key="6"
                  className="cancelButton ml1 mt3"
                  onClick={props.handleRowClick}
                >
                  Back
                </Button>
              </TabPane>
              <TabPane tab="Card" key="fields1">
                <div style={{ flexWrap: "wrap", gap: "2rem", display: "flex" }}>
                  {userCardsList?.map((ele) => {
                    return (
                      <div
                        className="debit-card cursor"
                        onClick={() => {
                          if (ele) {
                            history.push({
                              pathname: `/card-details/${ele.id}`,
                              state: { cardData: ele },
                            });
                          }
                        }}
                        style={{ maxWidth: 250 }}
                      >
                        {/* <h2>{ele.company_name}</h2> */}
                        <div
                          className="mt1 ref bottom-margin"
                          style={{ bottom: "5.5rem" }}
                        >
                          <span>
                            {ele?.data?.maskCardNumber?.substr(0, 4)} XXXX XXXX{" "}
                            {ele?.data?.maskCardNumber?.substr(15)}
                          </span>
                          <br />
                          <span style={{ marginTop: 5, fontSize: "0.85rem" }}>
                            {ele?.card_reference_no}
                          </span>
                        </div>
                        <div
                          className="flex-between mt1 emp bottom-margin"
                          style={{ bottom: "3.5rem" }}
                        >
                          <span style={{ fontSize: "0.85rem" }}>
                            {ele?.employee_details?.name
                              ? ele?.employee_details?.name
                              : ele.data?.firstName + " " + ele.data?.lastName}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </TabPane>
            </>
          )}
        </Tabs>
      </div>
    </>
  );
};

export default UserDetails;
